import { FC } from 'react';

import { Card, SimpleTable, TableBody, VSpacing } from '@hh.ru/magritte-ui';

import { EditUserForm } from 'components/Admin/UserDetail/EditUserForm/EditUserForm';
import { UsersTableHeader } from 'components/Admin/Users/UsersTable/UsersTableHeader';
import { UsersTableRow } from 'components/Admin/Users/UsersTable/UsersTableRow';

import { useSelector } from 'store/utils';

export const UserDetail: FC = () => {
    const { user } = useSelector((state) => state.userDetail);

    return (
        <>
            <Card borderWidth="default" stretched>
                <SimpleTable divider padding={20} stretched>
                    <UsersTableHeader hideActions />
                    <TableBody>
                        <UsersTableRow hideActions {...user} />
                    </TableBody>
                </SimpleTable>
            </Card>
            <VSpacing default={24} />
            <EditUserForm
                personalManagerId={user.personalManagerId}
                personalManagerEmail={user.personalManagerEmail}
                useHHManager={user.useHHManager}
            />
        </>
    );
};
